import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons'; // <-- Icône de profil
import '../styles/NavbarFooter.css';

import DailyMenuPdf from './DailyMenuPdf';

const Navbar = () => {
  return (
    <nav id="navbar">
      <div className="navbar-left">
        <a href='/'><img src="/images/ilrialtologo.jpg" alt="Il Rialto Logo" className="logo" /></a>
      </div>
      <div className="navbar-center">
        <a href="https://ilrialto.be" target="_blank" rel="noopener noreferrer">Voir le site</a>
        
        

      </div>
      <div className="navbar-right">
        <Link to="/login" className="login-icon" title="Se connecter">
          <FontAwesomeIcon icon={faUser} />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
